import { FrameBody, Title } from "@npd-ng/adp-benchmark";
import { Button, Container, Form, Spinner, Stack } from "react-bootstrap";
import {  useEffect, useRef, useState } from "react";
import { Content } from "../types/Content";
import { useSetupCodeValidationService } from "../hooks/useSetupCodeValidationService";
import { actions } from "../state";
import { useStateContext } from "../hooks/useStateContext";
import { checkNetworkState } from "../hooks/useNetworkService";
const logPrefix = "[ADPClient][SetupCodeValidationView]"
export default function SetupCodeValidationView() {
  const { state, dispatch } = useStateContext();
  console.log(logPrefix, "validation details");
  console.table({providedSetupCode:state.sessionState.providedSetupCode, schoolDetails:{...state.sessionState.schoolDetails} });
    const content= state.staticContent as Content;
    const setupCodeContent = content?.deviceReadiness.setupCode as Content["deviceReadiness"]["setupCode"];
    const setupCodeElemnts: HTMLInputElement[] = [];
    const inputRef = useRef(setupCodeElemnts);
    const submitRef = useRef<HTMLButtonElement>(null);
    const [disableSubmit, setDisableSubmit] = useState(state.sessionState.providedSetupCode?.length !==4);
    const {validateSetUpCode,resetSchoolDetails,cancelSetupCodeValidation} = useSetupCodeValidationService(dispatch, state);
    const getSetupCode = ()=>{
     const setupcode=inputRef?.current[0]?.value;
      return setupcode.toUpperCase();
    }
    const onSetupCodeSubmit = ()=>{
      const warning = checkNetworkState(state.sessionState.networkConnectionState,state.sessionState.selectedAssessmentMode);
      if(warning) {
          dispatch(actions.createWarningAction(warning));
          return;
      }
        setDisableSubmit(true);
        validateSetUpCode(getSetupCode());
    }
    useEffect(() => {
      if(!disableSubmit)submitRef?.current?.focus();
      if(getSetupCode().length === 0){
        inputRef?.current[0]?.focus()
      }
    }, [disableSubmit]);
    const onKeyUp = (e:any)=>{
      if(e && e.target){
        if (e.key === "Backspace" || e.key === "Delete") {
          setDisableSubmit(true);
          } else {
          if (getSetupCode().length === 4){
            setDisableSubmit(false);
            submitRef?.current?.focus();
           
          }
          else {
            setDisableSubmit(true);
          }
        }
      }
       }
      const onkeyDown =(e:any)=>{
        if (!(/[A-Z0-9]/gi.test(e.key) || e.keyCode === 8)) {
          e.preventDefault();
          return;
        } 
        if(state.sessionState.schoolDetails?.errorCode){
          resetSchoolDetails();
        }
      }
      const onCancel =()=>{
        cancelSetupCodeValidation();
      }
     
      const handleChange = (event: { target: { value: string; }; }) => {
        dispatch(actions.createUpdateSchoolAction({status:"validating", setupCode:event.target.value}));
      };
    
    return (
     <Container>
          <FrameBody>
        <Container>

        <Title  content={content?.deviceReadiness.title} />
            </Container>
    
      <Stack  direction="horizontal" className="d-grid gap-2">
      <Container id="setupCodeContainer">
      <Form.Label  id="setupCodeLabel" htmlFor="setupcode">
        {setupCodeContent.title}
      </Form.Label>
      <Stack  direction="horizontal" className="d-row gap-4">
      {[1].map((elem, index) => (
         <Form.Control
         key={index}
         type="input"
         maxLength={4}
         aria-describedby="setupcodeblock"
         className="setupCodeInput"
         ref={(element: HTMLInputElement) => {inputRef.current[index] = element; setupCodeElemnts.push(element)}}
         onKeyUp={onKeyUp}
         onKeyDown={onkeyDown}
         onChange={handleChange}
         id={index.toString()}
         value={state.sessionState.providedSetupCode}
       /> 
      ))}
      </Stack>
      <div className="mt-4">
      <Button
        className="btn-custom btn-custom-primary mr-4"
        disabled={disableSubmit}
        variant="primary"
        size="lg"
        ref={submitRef}
        onClick={onSetupCodeSubmit}
      >
        {state.deviceReadinessState.validationState === "setupCodeValidation"  &&  <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{' '}
            Verifying...
          </>}
          {state.deviceReadinessState.validationState === undefined && content?.actions.submit}
      </Button>
      {' '} 
      <Button
        className="btn-custom btn-custom-secondary"
        size="lg"
        type="button"
        variant="secondary"
        onClick={onCancel}
      >
        {content?.actions.cancel}
      </Button>
      {state.sessionState.schoolDetails?.errorCode &&
        <Form.Text id="setupcodeblock" muted>
          <div id="setupCodeErrorText">
              <br />
                <span>{setupCodeContent.errorText}</span>
            </div>
      </Form.Text>
      }
      </div>
      </Container>
    </Stack>
    </FrameBody>
  </Container>

    )
  }